<script setup lang="ts">
import { TABLE_HEAD_TYPE } from "./useTable";
import { useTableHead } from "./useTableHead";

/**
 * **TableHead** (`e-table-head`)
 *
 * Renders the header section of a `<e-table>`, containing header rows.
 * This component is a structural wrapper — it holds no logic.
 * Props are registered in the shared stateStore so `useTable` can
 * resolve the parent–child hierarchy (Table → TableHead → TableRow → TableHeaderCell).
 *
 * @example
 * ```html
 * <e-table>
 *   <e-table-head>
 *     <e-table-row>
 *       <e-table-header-cell>Name</e-table-header-cell>
 *       <e-table-header-cell>Age</e-table-header-cell>
 *     </e-table-row>
 *   </e-table-head>
 * </e-table>
 * ```
 */
defineOptions({
  name: TABLE_HEAD_TYPE,
});

const { classes } = useTableHead();
</script>

<style lang="css">
/* Ensure the host does not interfere with the CSS grid layout of the parent table. */
:host {
  display: contents;
}
</style>

<template>
  <div part="head" :class="classes">
    <slot />
  </div>
</template>
